import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";
import { ProductivitySection } from "./ProductivitySection";

export const SettingsProductivity: FC = () => {
  useTrackPageVisit("app/settings_productivity/visit");

  return (
    <div className="flex flex-col gap-6 mt-2">
      <div className="flex flex-col gap-2">
        <h3 className="text-2xl font-semibold">
          <FormattedMessage
            id="settings.productivity"
            defaultMessage="Productivity"
          />
        </h3>
        <span className="text-sm text-muted-foreground">
          <FormattedMessage
            id="settings.productivity.hint"
            defaultMessage="Track team productivity metrics including uploads, exports, and contributions"
          />
        </span>
      </div>
      <ProductivitySection />
    </div>
  );
};
